(function () {
  const Core = window.RB.Core;
  const { equip, buff } = window.RB.CardLib;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Bandle Soldier": { entersReadyCond: { k: "xp", n: 3 } },

    "Divining Shells": {
      abilities: [
        {
          cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
          killSelf: true,
          exhausts: true,
          action: true,
          label: "Divining Shells",
          targets: [{ bind: "t1", spec: { type: "unit" }, prompt: "Give +2 Might to..." }],
          program: [buff("$t1", 2)],
        },
      ],
    },

    "Enthralling Protector": {
      abilities: [
        {
          cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
          costXp: 2,
          label: "Enthralling Protector",
          targets: [],
          program: [{ op: "buff", to: "source" }],
        },
      ],
    },

    "Poppy, Defender of the Meek": {
      addCosts: [
        {
          optional: true,
          cond: null,
          label: "Poppy, Defender of the Meek",
          costXp: 3,
          discount: { energy: 3, pips: 0, anyPower: 0, domains: null },
        },
      ],
    },

    "Sacrifice": {
      play: [{ op: "draw", n: 2 }, { op: "channel", n: 1, exhausted: true }],
      addCosts: [
        {
          optional: false,
          cond: null,
          label: "Sacrifice",
          costKill: { type: "unit", mighty: true },
        },
      ],
    },

    "Scrutinizing Sergeant": {
      play: [{ op: "xp", n: { count: { type: "unit", friendly: true }, times: 1 } }],
    },

    "Shepherd's Heirloom": {
      play: [{ op: "xp", n: 1 }],
      abilities: [
        equip({ energy: 0, pips: 0, anyPower: 0, domains: null }, { costXp: 1 }),
      ],
    },

    "Soul Harvest": {
      play: [{ op: "kill", to: "$t1" }],
      targets: [
        {
          bind: "t1",
          spec: { type: "unit", maxMight: 3, atBf: true },
          prompt: "Kill...",
        },
      ],
    },

    "Stalking Wolf": {
      addCosts: [
        {
          optional: false,
          cond: null,
          label: "Stalking Wolf",
          costKill: { type: "unit", tags: ["Bird", "Cat", "Dog", "Poro"] },
          playToPaidBf: true,
        },
      ],
    },

    "The Ruination": { play: [{ op: "kill", spec: { type: "unit" } }] },

    "Vi, Peacekeeper": {
      triggers: [
        {
          on: "attack",
          optional: false,
          label: "When I attack, [Stun] an enemy unit here",
          targets: [
            {
              bind: "t1",
              spec: { type: "unit", enemy: true, here: true },
              prompt: "Stun...",
            },
          ],
          program: [{ op: "stun", to: "$t1" }],
          self: true,
        },
      ],
    },

    "Black Rose Dignitary": {
      deathknell: [{ op: "channel", n: 1, exhausted: true }],
    },

    "Carrion Dredger": {
      deathknell: [{ op: "token", name: "Bird", n: 1 }],
    },

    "Crimson Pigeons": {
      selfMightSpecs: [{
        n: 2,
        cond: {
          k: "and",
          conds: [
            { k: "selfAttacking" },
            { k: "count", spec: { type: "unit", friendly: true, inCombat: true, other: true }, n: 1 },
          ],
        },
      }],
    },

    "Heroic Charge": {
      targets: [
        { bind: "t1", spec: { type: "unit", friendly: true }, prompt: "Give +1 :rb_might: this turn to which friendly unit?" },
        { bind: "t2", spec: { type: "unit", enemy: true, sameLocAs: "t1" }, prompt: "Stun which enemy unit at its location?" },
      ],
      play: [
        buff("$t1", 1),
        { op: "stun", to: "$t2" },
      ],
    },

    "Loyal Poro": {
      deathknell: [{
        op: "if",
        cond: {
          k: "or",
          conds: [
            { k: "unitsHereAtLeast", n: 1 },
            {
              k: "and",
              conds: [
                { k: "not", cond: { k: "ctxBf" } },
                { k: "count", spec: { type: "unit", friendly: true, inBase: true }, n: 1 },
              ],
            },
          ],
        },
        then: [{ op: "draw", n: 1 }],
      }],
    },

    "Ultrasoft Poro": {
      abilities: [{
        label: "Exhaust: play two 1 :rb_might: Bird tokens with [Deflect]",
        exhausts: true,
        needBf: true,
        targets: [],
        program: [{ op: "token", name: "Bird", n: 2 }],
      }],
    },

    "Safety Inspector": {
      addCosts: [
        {
          optional: true,
          cond: null,
          label: "Safety Inspector",
          costXp: 3,
          then: [
            {
              op: "choose", bind: "si", byOpponent: true,
              spec: { type: "unit", enemy: true },
              prompt: "Kill one of your units",
            },
            { op: "kill", to: "$si", credit: false },
          ],
          otherwise: [
            {
              op: "choose", bind: "sf", spec: { type: "unit", friendly: true },
              prompt: "Kill one of your units",
            },
            { op: "kill", to: "$sf", credit: false },
            {
              op: "choose", bind: "si", byOpponent: true,
              spec: { type: "unit", enemy: true },
              prompt: "Kill one of your units",
            },
            { op: "kill", to: "$si", credit: false },
          ],
        },
      ],
    },

    "Starhound": {
      targets: [{
        bind: "t",
        spec: {
          orSpecs: [
            { zone: "trash", tag: "Bird" },
            { zone: "trash", tag: "Cat" },
            { zone: "trash", tag: "Dog" },
            { zone: "trash", tag: "Poro" },
          ],
        },
        prompt: "Return which Bird, Cat, Dog or Poro from your trash to your hand?",
      }],
      play: [{ op: "toHand", to: "$t" }],
    },

    "Undying Loyalty": {
      targets: [{
        bind: "t",
        spec: { zone: "trash", type: "unit", maxEnergy: 2, maxPips: 1 },
        prompt: "Play which unit from your trash, ignoring its cost?",
      }],
      play: [{ op: "playFrom", to: "$t", waive: "all" }],
      costMods: [{
        energyLess: 2,
        targetsMatching: {
          orSpecs: [
            { zone: "trash", tag: "Bird" },
            { zone: "trash", tag: "Cat" },
            { zone: "trash", tag: "Dog" },
            { zone: "trash", tag: "Poro" },
          ],
        },
      }],
    },

    "Atakhan": {
      addCosts: [{
        optional: true,
        cond: null,
        label: "Atakhan",
        costKill: { type: "unit" },
        discountPerKilledCost: {
          energy: { energy: 1, pips: 0, anyPower: 0, domains: null },
          power: { energy: 0, pips: 1, anyPower: 0, domains: ["order"] },
        },
      }],
      triggers: [{
        on: "attack",
        self: true,
        optional: false,
        label: "the defender must kill one of their units here",
        targets: [],
        program: [
          {
            op: "choose",
            bind: "_ak",
            byOpponent: true,
            spec: { type: "unit", enemy: true, here: true, ignoreUntargetable: true },
            prompt: "Atakhan: kill one of your units here",
          },
          { op: "kill", to: "$_ak" },
        ],
      }],
    },

    "LeBlanc, Fragmented": {
      deathknell: [{
        op: "if",
        cond: { k: "and", conds: [{ k: "myTurn" }, { k: "phase", phase: "beginning" }] },
        then: [{ op: "draw", n: 2 }],
        else: [{ op: "draw", n: 1 }],
      }],
    },

    "Shard of Undoing": {
      triggers: [{
        on: "dies",
        oncePerTurn: true,
        optional: false,
        label: "friendly unit dies in your Beginning Phase: each opponent kills a unit",
        targets: [],
        condSpec: {
          k: "and",
          conds: [
            { k: "evSnapshotFriendly" },
            { k: "evSnapshotUnit" },
            { k: "myTurn" },
            { k: "phase", phase: "beginning" },
          ],
        },
        program: [{ op: "eachKills", skipController: true }],
      }],
    },

    "Tactical Retreat": {
      targets: [{
        bind: "t",
        spec: { type: "unit", friendly: true },
        prompt: "The next time it would die this turn, heal, exhaust and recall which friendly unit?",
      }],
      play: [{ op: "deathReplaceRecall", to: "$t" }],
    },

    "Ivern, Friend to All": {
      triggers: [
        {
          on: "unitConquer",
          self: true,
          optional: false,
          label: "conquer: score 1 if your units cover Bird, Cat, Dog and Poro",
          targets: [],
          program: [{
            op: "if",
            cond: {
              k: "and",
              conds: [
                { k: "controlsTag", tag: "Bird" },
                { k: "controlsTag", tag: "Cat" },
                { k: "controlsTag", tag: "Dog" },
                { k: "controlsTag", tag: "Poro" },
              ],
            },
            then: [{ op: "points", n: 1 }],
          }],
        },
        {
          on: "unitHold",
          self: true,
          optional: false,
          label: "hold: score 1 if your units cover Bird, Cat, Dog and Poro",
          targets: [],
          program: [{
            op: "if",
            cond: {
              k: "and",
              conds: [
                { k: "controlsTag", tag: "Bird" },
                { k: "controlsTag", tag: "Cat" },
                { k: "controlsTag", tag: "Dog" },
                { k: "controlsTag", tag: "Poro" },
              ],
            },
            then: [{ op: "points", n: 1 }],
          }],
        },
      ],
      play: [
        {
          op: "option", varKey: "iv",
          prompt: "Which tag do I gain?",
          options: ["Bird", "Cat", "Dog", "Poro"],
        },
        {
          op: "if", cond: { k: "varEq", key: "iv", value: 0 },
          then: [{ op: "grant", to: "source", tag: "Bird", dur: "perm" }],
        },
        {
          op: "if", cond: { k: "varEq", key: "iv", value: 1 },
          then: [{ op: "grant", to: "source", tag: "Cat", dur: "perm" }],
        },
        {
          op: "if", cond: { k: "varEq", key: "iv", value: 2 },
          then: [{ op: "grant", to: "source", tag: "Dog", dur: "perm" }],
        },
        {
          op: "if", cond: { k: "varEq", key: "iv", value: 3 },
          then: [{ op: "grant", to: "source", tag: "Poro", dur: "perm" }],
        },
      ],
    },

    "Rift Herald": {
      triggers: [{
        on: "move",
        self: true,
        optional: false,
        label: "move to a battlefield: dig 3 for a unit",
        targets: [],
        condSpec: { k: "evToBf" },
        program: [{
          op: "lookTopTake",
          n: 3,
          optional: true,
          public: true,
          take: "hand",
          filter: { type: "unit" },
          prompt: "Reveal a unit from among them and draw it (choose none to recycle all 3)",
        }],
      }],
      deathknell: [
        {
          op: "choose",
          bind: "_rh",
          spec: { zone: "hand", type: "unit" },
          prompt: "Play which unit from your hand to your base, ignoring its Energy cost?",
        },
        { op: "playFrom", to: "$_rh", waive: "energy", dest: "base" },
      ],
    },

    "Mageseeker Investigator": {
      moveTaxHere: { anyPower: 1 },
    },

    "Shadow's Call": {
      targets: [{
        bind: "t", spec: { type: "unit", friendly: true, notHasKw: "temporary" },
        prompt: "Give which friendly unit [Temporary]?",
      }],
      play: [
        { op: "grant", to: "$t", keyword: "temporary", dur: "perm" },
        { op: "draw", n: 2 },
      ],
    },

    "Ashe, Focused": {
      play: [
        {
          op: "revealHandPick", who: "opponent", bind: "af",
          prompt: "Banish which revealed card?",
        },
        { op: "banish", to: "$af" },
        {
          op: "delayed", on: "hold", forPlayer: "opponent", dur: "game", repeat: false,
          carry: ["af"],
          label: "Ashe, Focused: return the banished card to its owner's hand",
          program: [{ op: "toHand", to: "$af" }],
        },
      ],
    },

    "Galio, Indefatigable": {
      noCombatDamage: true,
    },
  });
})();
